import { render, staticRenderFns } from "./QualificationLevelList.vue?vue&type=template&id=c2f92000&scoped=true&"
import script from "./QualificationLevelList.vue?vue&type=script&lang=js&"
export * from "./QualificationLevelList.vue?vue&type=script&lang=js&"
import style0 from "./QualificationLevelList.vue?vue&type=style&index=0&id=c2f92000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f92000",
  null
  
)

export default component.exports